'use client'

import { useEffect, useRef } from 'react'
import { useSession } from 'next-auth/react'
import { umamiIdentify } from './umami-identify'

/**
 * Umami User Sync Component
 *
 * Identifica o usuário autenticado na sessão Umami após o login,
 * usando nome e e-mail como identificadores da sessão.
 * Deve ser renderizado dentro do SessionProvider (NextAuthProvider).
 */
export function UmamiUserSync() {
  const { data: session, status } = useSession()
  const lastIdentifiedRef = useRef<string | null>(null)

  // Deps primitivas evitam rajada: NextAuth reemite o objeto session em
  // foreground/polling/refresh, e o effect com dep [session] disparava
  // múltiplos identify por sessão — causando rajada P2025 no Umami.
  const email = ((session?.user as any)?.mail as string | undefined) || session?.user?.email
  const name = ((session?.user as any)?.fullName as string | undefined) || session?.user?.name

  useEffect(() => {
    if (status !== 'authenticated' || !email) return
    if (lastIdentifiedRef.current === email) return

    lastIdentifiedRef.current = email
    umamiIdentify(email, { name: name || '', email })
  }, [status, email, name])

  return null
}
